<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="ded"></a><span>To my daughters, Miriam and Louise,<br/>who put up with my mishegoss.</span></p>
<p class="ded1"><span>Special Dedication:<br/>To Peter, Bob, Howie, Bob, and Andre:<br/>The staff of <i>Youth’s Companion</i> wouldn’t have been<br/>the same without you.<br/>Thanks for twenty years of Fandom.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?52fbe424